import { render, staticRenderFns } from "./CustomRadio.vue?vue&type=template&id=47200fa8"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports